import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ScheduleConfigService } from '@/openapi';
import type { HolidayWithShifts } from '@/pages/scheduleConfig/Holidays';
import { queryKeys } from '@/util/queryKeys';

export const useCreateHolidayMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (holiday: HolidayWithShifts) => {
      const holidayOnly = {
        ...holiday,
        shifts: undefined,
      };
      const newHoliday =
        await ScheduleConfigService.scheduleConfigServiceCreateHoliday({
          body: holidayOnly,
        });
      if (holiday.shifts?.length) {
        await ScheduleConfigService.scheduleConfigServiceUpdateHolidayShifts({
          path: { id: newHoliday.data.id },
          body: {
            shifts: holiday.shifts.map((shift) => ({
              shiftId: shift.shiftId,
              points: shift.points,
            })),
          },
        });
      }
      return newHoliday;
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: queryKeys.holidays.list() }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.holidays.withShifts(),
        }),
        queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all }),
      ]);
    },
  });
};
